import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { ToastModule } from 'primeng/toast';
import { PosthogService } from './core/services/posthog.service';
import { ERROR_TOAST_KEY } from './services/error-toast.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, ToastModule, TranslocoPipe]
})
export class AppComponent {
  title = 'traceability-pro-max-FE';
  readonly errorToastKey = ERROR_TOAST_KEY;

  constructor() {
    inject(PosthogService);
  }
}
